var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "save-wrapper-component",
    {
      ref: "backupFilePreviewDialogRef",
      attrs: {
        "max-width": "800px",
        name: _vm.name,
        title: _vm.$t("Dialogs.BackupSettings.PreviewTitle"),
        scrollable: true,
      },
    },
    [
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c("v-card-text", [
            _c("div", { staticClass: "backup-file-preview" }, [
              _c("pre", [_vm._v(_vm._s(_vm.fileContent))]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }